/**
 * Examines the user agent to determine if the user has announced itself as a bot
 * https://en.wikipedia.org/wiki/Internet_bot
 *
 * @returns {Boolean} true if the user is a known bot, false otherwise
 */
export function isBot(): boolean {
	const botSignatures =
		/(baiduspider|bingbot|crawler|duckduckbot|exabot|facebookexternalhit|facebot|googlebot|googlepreview|ia_archiver|mediapartners-google|slurp|sogou|twitterbot|uptime.com|whatsapp|yandexbot)/;
	return botSignatures.test(window.navigator.userAgent.toLowerCase());
}
